import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";

const AllSalesManReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
  const[cust, setCust] = useState(null)
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1, 'months').format(),
    toDate : moment().format()
  })
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }
  useEffect(() => {
    getSupplierData();
  }, []);
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    maxWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "salesmanCode",
    headerName: "Salesman Code",
    minWidth:150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "Salesman Name",
    flex: 1,
    minWidth:150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "OutletName",
    headerName: "Outlet Name",
    minWidth:150,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "total_bills",
    headerName: "Total Bills",
    minWidth:100,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sales",
    headerName: "Overall Branch Wise Sales",
    minWidth:220,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "return",
    headerName: "Return",
    minWidth:130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "avg_bills",
    headerName: "Avg Bills",
    minWidth:130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },

]

const rows = _.map(data,(val,idx)=>({
  id: idx+1,
  sno: idx+1,
  name : val.sales_man_name,
  sales : parseFloat(val.sales).toFixed(2),
  total_bills:val.total_bills,
  return:val.return,
  avg_bills:parseFloat(val.avg_bills).toFixed(2),
  salesmanCode:val.sales_man_code,
  OutletName:val.fullname === "" ? "-" : val.fullname
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.avg_bills);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
function handleSalesmanReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
    // outletid:cust !== null ? cust.id : 0
  }
  console.log(postData)
  // axios.post('/v1/reports/salesman/ledger', postData)
  axios.post(`/v1/reports/salesman/getall` ,postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", err.response.data.errors[0].message));
  })
}
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesmanReport()
    }
  },[rowsPerPage, page, dateLimit])
  return (
    <Fragment>
      <Helmet>All Salesman Reports</Helmet>
      <Typography variant="h6">All Salesman Reports</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
      {/* <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.fullname} 
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid> */}
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
    </Fragment>
  );
};

export default memo(AllSalesManReport);
